<template>
    <HomeNav />
        <slot />
    <WhatsAppButton />
    <HomeFooter />
</template>

<script setup>
import HomeNav from '@/components/pages/Home/Nav.vue';
import WhatsAppButton from '@/components/buttons/WhatsAppButton.vue';
import HomeFooter from '@/components/pages/Home/Footer.vue';
</script>